export default "__VITE_ASSET__CQ6r0MUw__"